import { Link } from 'react-router-dom';

// Logolar: public/ klasöründen (Vite'da kök olarak sunulur)
const LOGO_ASIM = '/asimlogo.png';
const LOGO_EPIKED = '/logo.avif';

export default function Footer() {

  return (
    <footer className="bg-[#0e0c0a] text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-light text-white mb-6 tracking-wider font-serif">İletişim</h3>
            <div className="space-y-3 font-light font-sans text-sm">
              <p className="flex items-start">
                <i className="ri-phone-line text-lg mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                <span>+90 537 961 99 20</span>
              </p>
              <p className="flex items-start">
                <i className="ri-map-pin-line text-lg mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                <span>4. Levent Otosanayi Sitesi, Barbaros Cd No:4 Sarıyer İstanbul</span>
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-light text-white mb-6 tracking-wider font-serif">Hızlı Bağlantılar</h3>
            <div className="space-y-3 font-light font-sans text-sm">
              <Link to="/projeler" className="block hover:text-white transition-colors duration-300 cursor-pointer">
                Projeler
              </Link>
              <Link to="/studyo-asim-mete" className="block hover:text-white transition-colors duration-300 cursor-pointer">
                Stüdyo
              </Link>
              <Link to="/gravitas-libera" className="block hover:text-white transition-colors duration-300 cursor-pointer">
                Gravitas Libera
              </Link>
              <Link to="/iletisim" className="block hover:text-white transition-colors duration-300 cursor-pointer">
                İletişim
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#2a2018]">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <img 
              src={LOGO_ASIM} 
              alt="Studio Asım Mete Logo" 
              className="h-8 md:h-10 w-auto object-contain"
            />
            <p className="text-xs font-light text-white font-sans">
              © {new Date().getFullYear()} Studio Asım Mete. Tüm hakları saklıdır.
            </p>
          </div>

          {/* Epiked Credit - mobilde ortalı, masaüstünde sağda */}
          <div className="flex items-center justify-center md:justify-end gap-2 mt-4">
            <a 
              href="https://epiked.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-[#9ca3af] hover:text-[#60a5fa] transition-colors duration-300 text-xs font-light font-sans no-underline"
            >
              <img 
                src={LOGO_EPIKED} 
                alt="Epiked" 
                className="h-4 w-auto object-contain block"
              />
              <span>
                Profesyonel web sistemleri ile hazırlanmıştır.
              </span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}